<template>
    <div class="ai-form-check-box">
        <div class="dx-field dx-field-left">
            <div class="ai-form-check-box-label dx-field-label dx-field-label-left">
                <span :class="fieldLabelClass">
                    {{ meta.title }}
                </span>
                <div class="dx-field-item-required-mark" v-if="isRequiered">&nbsp;*</div>
            </div>
            <div class="dx-field-value dx-field-value-left">
                <dx-check-box
                    v-model:value="value"
                    @valueChanged="valueChanged"
                    iconSize="18"
                    class="custom-checkbox"
                />
                <div v-if="error" class="ai-dx-invalid"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import DxCheckBox from 'devextreme-vue/check-box';

const props = defineProps({
    meta: {
        type: Object,
        default: () => ({}),
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});
const validationResult = inject('validationResult');
const serverData = inject('serverData');
const userData = inject('userData');
const isRequiered = computed(() => {
    return props.meta.validationRules?.required;
});
const error = computed(() => {
    return validationResult.value.find(s => s.fieldNameText === props.meta.fieldNameText);
});

const valueChanged = e => {
    userDataChange(e.value);
};

const isModified = computed(() => {
    return userData?.value[props.meta.fieldNameText] !== serverData?.value[props.meta.fieldNameText];
});

const userDataChange = value => {
    validationResult.value = validationResult.value.filter(s => {
        return s.fieldNameText !== props.meta.fieldNameText;
    });
    userData.value[props.meta.fieldNameText] = value;
    props.callbacks.userDataChanged();
};

const value = computed(() => {
    if (userData?.value[props.meta.fieldNameText] === undefined) {
        return false;
    }
    return userData?.value[props.meta.fieldNameText];
});

const fieldLabelClass = computed(() => {
    return {
        'ai-field-modified': isModified.value,
    };
});

//.custom-checkbox .dx-checkbox-checked {
//}
//.dx-checkbox-checked .dx-checkbox-icon {
//    background-color: #fff;
//}
//.dx-checkbox-checked .dx-checkbox-icon::after {
//    content: url('@/assets/ai-formcheck-box-unchecked.svg');
//}
//.dx-checkbox-checked .dx-checkbox-icon::before {
//    content: url('@/assets/ai-formcheck-box-checked.svg');
//}
</script>
<style>
.custom-checkbox .dx-checkbox-icon {
    border-style: none;
}
.ai-form-check-box {
    display: flex;
    align-items: center; /* Выравнивание по вертикали */
}
.ai-form-check-box-label {
}
.dx-checkbox.custom-checkbox {
    .dx-checkbox-container {
        .dx-checkbox-icon {
            background-color: #ffffff;
            background-image: url('@/assets/ai-formcheck-box-unchecked.svg');
        }
        .dx-checkbox-icon::after {
            content: '';
        }
    }
}
.dx-checkbox.dx-checkbox-checked.custom-checkbox {
    .dx-checkbox-container {
        .dx-checkbox-icon {
            background-image: url('@/assets/ai-formcheck-box-checked.svg');
        }
        .dx-checkbox-icon::after {
            content: '';
        }
        .dx-checkbox-icon::before {
            content: '';
        }
    }
}

.dx-checkbox.dx-state-active .dx-checkbox-icon::after,
.dx-checkbox.dx-state-focused .dx-checkbox-icon::after {
    background-color: transparent;
}
.dx-checkbox.dx-checkbox-checked.dx-state-active .dx-checkbox-icon::after,
.dx-checkbox.dx-checkbox-checked.dx-state-focused .dx-checkbox-icon::after,
.dx-checkbox.dx-checkbox-indeterminate.dx-state-active .dx-checkbox-icon::after,
.dx-checkbox.dx-checkbox-indeterminate.dx-state-focused .dx-checkbox-icon::after {
    background-color: transparent;
}
</style>
